(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const COLLECTIONS = [
    { title: 'Pantis', handle: 'bombachas' },
    { title: 'Corpiños', handle: 'corpinos' },
    { title: 'Fragancias', handle: 'perfumes' },
    { title: 'Accesorios', handle: 'accesorios' },
    { title: 'Billeteras & Tarjeteros', handle: 'billeteras-tarjeteros' },
  ];

  const routeTo = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.endsWith('/') ? root : `${root}/`}${path.replace(/^\//, '')}`;
  };

  const createProductCard = (product) => {
    const card = document.createElement('a');
    card.className = 'gd-mobile-product-card';
    card.href = routeTo(`products/${product.handle}`);
    card.setAttribute('aria-label', product.title || 'Ver producto');

    const media = document.createElement('div');
    media.className = 'gd-mobile-product-card__media';

    const imageUrl = product.images?.[0]?.src || product.image?.src;
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.images?.[0]?.alt || product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }

    const title = document.createElement('div');
    title.className = 'gd-mobile-product-card__title';
    title.textContent = product.title || '';

    card.append(media, title);
    return card;
  };

  const loadCollection = async (config) => {
    try {
      const response = await fetch(
        routeTo(`collections/${config.handle}/products.json?limit=6`),
        { credentials: 'same-origin' }
      );

      if (!response.ok) return null;

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];
      if (!products.length) return null;

      return { ...config, products };
    } catch (error) {
      console.warn(`No se pudo cargar la colección ${config.handle}.`, error);
      return null;
    }
  };

  const buildShelf = (collection) => {
    const shelf = document.createElement('section');
    shelf.className = 'gd-mobile-collection-shelf';

    const header = document.createElement('div');
    header.className = 'gd-mobile-collection-shelf__header';

    const heading = document.createElement('h2');
    heading.className = 'gd-mobile-collection-shelf__title';
    heading.textContent = collection.title;

    const viewAll = document.createElement('a');
    viewAll.className = 'gd-mobile-collection-shelf__view-all';
    viewAll.href = routeTo(`collections/${collection.handle}`);
    viewAll.textContent = 'Ver todo';

    const track = document.createElement('div');
    track.className = 'gd-mobile-collection-shelf__track';
    track.setAttribute('role', 'list');
    track.setAttribute('aria-label', `Productos de ${collection.title}`);

    collection.products.forEach((product) => {
      const item = document.createElement('div');
      item.className = 'gd-mobile-collection-shelf__item';
      item.setAttribute('role', 'listitem');
      item.appendChild(createProductCard(product));
      track.appendChild(item);
    });

    header.append(heading, viewAll);
    shelf.append(header, track);
    return shelf;
  };

  const initializeMobileCollections = async () => {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    if (!document.querySelector('#MainContent[data-template^="index"]')) return;

    const featuredSection = document.querySelector('[id$="__product_list_themegen"]');
    if (!featuredSection || featuredSection.dataset.gdMobileCollections === 'true') return;

    featuredSection.dataset.gdMobileCollections = 'true';

    const loadedCollections = (await Promise.all(COLLECTIONS.map(loadCollection))).filter(Boolean);
    if (!loadedCollections.length) {
      delete featuredSection.dataset.gdMobileCollections;
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'gd-mobile-collections';

    loadedCollections.forEach((collection) => {
      wrapper.appendChild(buildShelf(collection));
    });

    const exploreMore = document.createElement('a');
    exploreMore.className = 'gd-mobile-collections__explore';
    exploreMore.href = routeTo('collections');
    exploreMore.textContent = 'Explorar más colecciones';
    wrapper.appendChild(exploreMore);

    featuredSection.appendChild(wrapper);
    featuredSection.classList.add('gd-mobile-collections-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileCollections, { once: true });
  } else {
    initializeMobileCollections();
  }

  window.matchMedia(MOBILE_QUERY).addEventListener?.('change', (event) => {
    if (event.matches) initializeMobileCollections();
  });

  document.addEventListener('shopify:section:load', initializeMobileCollections);
})();

(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const SECTION_SELECTOR = '[id$="__section_Ea3hn6"]';
  const BACKGROUND_URL = 'https://cdn.shopify.com/s/files/1/0775/9000/3864/files/acbb0693221c19662bf3069624a45092.png';
  const MOBILE_COPY = 'Explorá las demás marcas que tenemos disponibles para vos.';
  const MOBILE_BUTTON = 'Explorar ya!';
  const STYLE_ID = 'gd-mobile-more-brands-styles';

  const mobileStyles = () => `
    @media screen and (max-width: 749px) {
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready .gd-mobile-more-brands__panel {
        position: relative !important;
        isolation: isolate !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 12px !important;
        width: 100% !important;
        max-width: none !important;
        min-height: 430px !important;
        padding: 42px 24px 112px !important;
        overflow: hidden !important;
        text-align: center !important;
        background-color: #3b1824 !important;
        background-image:
          linear-gradient(
            to bottom,
            rgba(43, 15, 25, 0.18) 0%,
            rgba(43, 15, 25, 0.36) 52%,
            rgba(43, 15, 25, 0.76) 100%
          ),
          url("${BACKGROUND_URL}") !important;
        background-size: cover !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready .gd-mobile-more-brands__panel > [id$="__text_wrrtmK"],
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready .gd-mobile-more-brands__panel > [id$="__text_piLzYp"] {
        position: relative !important;
        z-index: 2 !important;
        width: 100% !important;
        max-width: 320px !important;
        margin: 0 auto !important;
        color: #ffffff !important;
        text-align: center !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_wrrtmK"],
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_wrrtmK"] *,
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_piLzYp"],
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_piLzYp"] * {
        color: #ffffff !important;
        text-align: center !important;
        text-shadow: 0 2px 12px rgba(0, 0, 0, 0.62) !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_wrrtmK"] p {
        margin: 0 !important;
        font-size: clamp(1.75rem, 8vw, 2.05rem) !important;
        line-height: 1.05 !important;
        font-weight: 700 !important;
        letter-spacing: -0.02em !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__text_piLzYp"] p {
        margin: 0 !important;
        font-size: 0.95rem !important;
        line-height: 1.42 !important;
        text-wrap: pretty !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__button_hPdQfz"] {
        position: absolute !important;
        left: 50% !important;
        right: auto !important;
        top: auto !important;
        bottom: 26px !important;
        z-index: 3 !important;
        width: max-content !important;
        max-width: calc(100% - 32px) !important;
        margin: 0 !important;
        transform: translateX(-50%) !important;
      }

      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__button_hPdQfz"] a,
      ${SECTION_SELECTOR}.gd-mobile-more-brands-ready [id$="__button_hPdQfz"] button {
        position: static !important;
        inset: auto !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        min-height: 46px !important;
        margin: 0 !important;
        padding: 12px 22px !important;
        transform: none !important;
        border: 1px solid rgba(255, 255, 255, 0.98) !important;
        border-radius: 14px !important;
        color: #481622 !important;
        background: rgba(255, 255, 255, 0.97) !important;
        box-shadow: 0 8px 24px rgba(28, 7, 14, 0.36) !important;
        font-weight: 500 !important;
        text-align: center !important;
        text-decoration: none !important;
        white-space: nowrap !important;
      }
    }
  `;

  const ensureStyles = () => {
    let style = document.getElementById(STYLE_ID);

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = mobileStyles();
  };

  const getElements = () => {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return {};

    const heading = [...section.querySelectorAll('h1, h2, h3, h4, h5, h6, p')]
      .find((element) => element.textContent.trim() === 'Más Marcas');

    const panel = section.querySelector('[id$="__group_GXUz9i"]')
      || heading?.closest('.group-block')
      || heading?.parentElement;

    const paragraph = section.querySelector('[id$="__text_piLzYp"] p')
      || [...section.querySelectorAll('p')]
        .find((element) => element.textContent.includes('Compartimos el mismo amor') || element.dataset.gdOriginalText);

    const button = section.querySelector('[id$="__button_hPdQfz"] a, [id$="__button_hPdQfz"] button')
      || [...section.querySelectorAll('a, button')]
        .find((element) => /Ir a Otras Marcas|Explorar ya!/i.test(element.textContent.trim()));

    return { section, panel, paragraph, button };
  };

  const applyMobileVersion = () => {
    if (!document.querySelector('#MainContent[data-template^="index"]')) return;

    const { section, panel, paragraph, button } = getElements();
    if (!section || !panel) return;

    ensureStyles();
    section.classList.add('gd-mobile-more-brands-ready');
    panel.classList.add('gd-mobile-more-brands__panel');

    if (paragraph) {
      if (!paragraph.dataset.gdOriginalText) {
        paragraph.dataset.gdOriginalText = paragraph.textContent;
      }
      paragraph.textContent = MOBILE_COPY;
    }

    if (button) {
      if (!button.dataset.gdOriginalText) {
        button.dataset.gdOriginalText = button.textContent;
      }
      button.textContent = MOBILE_BUTTON;
    }
  };

  const restoreDesktopVersion = () => {
    const { section, panel, paragraph, button } = getElements();
    if (!section) return;

    section.classList.remove('gd-mobile-more-brands-ready');
    panel?.classList.remove('gd-mobile-more-brands__panel');

    if (paragraph?.dataset.gdOriginalText) {
      paragraph.textContent = paragraph.dataset.gdOriginalText;
      delete paragraph.dataset.gdOriginalText;
    }

    if (button?.dataset.gdOriginalText) {
      button.textContent = button.dataset.gdOriginalText;
      delete button.dataset.gdOriginalText;
    }
  };

  const syncMobileMoreBrands = () => {
    if (window.matchMedia(MOBILE_QUERY).matches) {
      applyMobileVersion();
    } else {
      restoreDesktopVersion();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMobileMoreBrands, { once: true });
  } else {
    syncMobileMoreBrands();
  }

  window.matchMedia(MOBILE_QUERY).addEventListener?.('change', syncMobileMoreBrands);
  document.addEventListener('shopify:section:load', syncMobileMoreBrands);
})();
